export class CustomError extends Error {
  constructor(c: string, m: string) {
    super(m);
    this.code = c;
  }

  code: string = '';
}
